module.exports = __webpack_public_path__ + "static/media/29BDOS8.45402a8b.jpg";